import ShadowFlags from '../assets/flags/RoundedFlagShadowList';

const ShadowFlag = (cca3: string) : any => {
    let flag = '';
    if (cca3) {
        flag = CCY_TO_CCA3[cca3];
    }
    return ShadowFlags[flag];
}
export default ShadowFlag;

const CCY_TO_CCA3: any = {
    PHP : 'PHL_S',
    MYR : 'MYS_S',
    TWD : 'TWN_S',
    IDR : 'IDN_S',
    SGD : 'SGP_S',
    AUD : 'AUS_S',
    HKD : 'HKG_S',
    VND : 'VNM_S',
    EUR : 'EUR_S',
    GBP : 'GBR_S',
    CAD : 'CAN_S',
    JPY : 'JPN_S',
    CNH : 'CHN_S',
    INR : 'IND_S', //India
    DKK : 'DNK_S',
    CHF : 'CHE_S',
    KRW : 'KOR_S',
    THB : 'THA_S',
    NZD : 'NZD_S',
    NOK : 'NOK_S',
    SEK : 'SEK_S',
    USD : 'USD_S'
}
